import { Link } from 'react-router-dom';
import MovieCard from '@/components/feature/MovieCard';
import type { Movie } from '@/mocks/movies';

interface MovieGridProps {
  title: string;
  subtitle?: string;
  linkTo?: string;
  linkLabel?: string;
  movies: Movie[];
  variant?: 'default' | 'featured';
}

export default function MovieGrid({ title, subtitle, linkTo, linkLabel, movies, variant = 'default' }: MovieGridProps) {
  return (
    <section className="w-full max-w-[1400px] mx-auto px-4 md:px-6 py-8 md:py-10">
      <div className="flex items-center justify-between mb-5 md:mb-6">
        <div>
          <h3 className="text-lg md:text-xl font-heading font-bold text-foreground-50">
            {title}
          </h3>
          {subtitle && (
            <p className="text-sm text-foreground-500 mt-1">{subtitle}</p>
          )}
        </div>
        {linkTo && linkLabel && (
          <Link
            to={linkTo}
            className="flex items-center gap-1 text-sm text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer"
          >
            {linkLabel}
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-s-line"></i>
            </div>
          </Link>
        )}
      </div>

      {variant === 'featured' ? (
        <div className="space-y-4">
          {movies.map((movie) => (
            <MovieCard key={movie.id} movie={movie} variant="featured" />
          ))}
        </div>
      ) : (
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 gap-4 md:gap-5">
          {movies.map((movie) => (
            <MovieCard key={movie.id} movie={movie} />
          ))}
        </div>
      )}
    </section>
  );
}